export const DONATION_CATEGORIES = [
  {
    value: "EDUCATION",
    label: "Education",
    description: "Scholarships, tuition, and school supplies",
  },
  {
    value: "MEDICAL",
    label: "Medical",
    description: "Healthcare, hospital bills, and medication",
  },
  {
    value: "CHILD_CARE",
    label: "Child Care",
    description: "Daycare, foster care, adoption support",
  },
  {
    value: "FOOD_ASSISTANCE",
    label: "Food Assistance",
    description: "Hunger relief, food banks, meals",
  },
  {
    value: "HOUSING",
    label: "Housing",
    description: "Shelter, rent, and housing assistance",
  },
  {
    value: "DISASTER_RELIEF",
    label: "Disaster Relief",
    description: "Aid for floods, fires, hurricanes, etc.",
  },
  {
    value: "ANIMAL_WELFARE",
    label: "Animal Welfare",
    description: "Animal rescue and shelters",
  },
  {
    value: "ENVIRONMENT",
    label: "Environment",
    description: "Tree planting, conservation, recycling",
  },
  {
    value: "COMMUNITY_DEVELOPMENT",
    label: "Community Development",
    description: "Local infrastructure and youth programs",
  },
  {
    value: "WOMEN_EMPOWERMENT",
    label: "Women Empowerment",
    description: "Gender equality and small business support",
  },
  {
    value: "HUMAN_RIGHTS",
    label: "Human Rights",
    description: "Legal aid, advocacy, and protection initiatives",
  },
  {
    value: "MENTAL_HEALTH",
    label: "Mental Health",
    description: "Counseling, awareness, rehabilitation",
  },
  {
    value: "ELDERLY_SUPPORT",
    label: "Elderly Support",
    description: "Senior care and companionship",
  },
  {
    value: "SPORTS_AND_RECREATION",
    label: "Sports & Recreation",
    description: "Youth sports and facilities",
  },
  {
    value: "TECHNOLOGY_ACCESS",
    label: "Technology Access",
    description: "Devices and digital literacy programs",
  },
  {
    value: "CLEAN_WATER",
    label: "Clean Water",
    description: "Wells, sanitation, and filtration systems",
  },
  {
    value: "ART_AND_CULTURE",
    label: "Art & Culture",
    description: "Heritage, museums, and performances",
  },
  {
    value: "RELIGIOUS_OUTREACH",
    label: "Religious Outreach",
    description: "Faith-based charity and missions",
  },
  {
    value: "PUBLIC_HEALTH",
    label: "Public Health",
    description: "Vaccination, hygiene, preventive care",
  },
  {
    value: "EMERGENCY_RESPONSE",
    label: "Emergency Response",
    description: "First responders and crisis intervention",
  },
  {
    value: "EDUCATION_MATERIALS",
    label: "Education Materials",
    description: "Books and online courses",
  },
  {
    value: "RESEARCH_AND_INNOVATION",
    label: "Research & Innovation",
    description: "Scientific and social innovation projects",
  },
  {
    value: "REFUGEE_SUPPORT",
    label: "Refugee Support",
    description: "Resettlement and training",
  },
  {
    value: "AGRICULTURE_SUPPORT",
    label: "Agriculture Support",
    description: "Farming aid and sustainability",
  },
  {
    value: "CLEAN_ENERGY",
    label: "Clean Energy",
    description: "Renewable energy projects",
  },
  {
    value: "JOB_TRAINING",
    label: "Job Training",
    description: "Vocational and employment programs",
  },
  {
    value: "MICRO_FINANCE",
    label: "Micro Finance",
    description: "Small business and entrepreneurship loans",
  },
  {
    value: "TRANSPORT_ASSISTANCE",
    label: "Transport Assistance",
    description: "Commuting and logistics aid",
  },
  {
    value: "GENERAL_DONATION",
    label: "General Donation",
    description: "Default general-purpose donations",
  },
  {
    value: "SINGLE_MOTHERS",
    label: "Single Mothers",
    description: "Support programs for single mothers",
  },
  {
    value: "SINGLE_FATHERS",
    label: "Single Fathers",
    description: "Support programs for single fathers",
  },
  {
    value: "SINGLE_PARENTS",
    label: "Single Parents",
    description: "Assistance for single-parent households",
  },
  {
    value: "ENROLLMENT",
    label: "Enrollment",
    description: "Student or program enrollment-related credits",
  },
  {
    value: "PROMOTION",
    label: "Promotion",
    description: "Promotional credits or campaigns",
  },
  {
    value: "OTHER",
    label: "Other",
    description: "Other or unspecified purpose",
  },
];
